import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { AccountManager, DashboardStatistics, ShareGraph } from '../models/AccountStatus';

export const onActivate = async (start_now: boolean) => {
	try {
		const response = await axios.put('dashboard/activate-subscription', { start_now });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetDashboard = async () => {
	try {
		const response = await axios.get<JsonResponse<{ statistics: DashboardStatistics }>>('dashboard/home');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetCustomerSupport = async () => {
	try {
		const response = await axios.get<JsonResponse<AccountManager>>('dashboard/customer-support/account-manager');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onPostTechnicalSupport = async (description: string) => {
	try {
		const response = await axios.post<JsonResponse<AccountManager>>('dashboard/customer-support/technical-support', { description });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetRemainingEmergency = async () => {
	try {
		const response = await axios.get<JsonResponse<{ remaining_messages: number }>>('dashboard/customer-support/remaining-messages');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onPostEmergencyRequest = async (description: string) => {
	try {
		const response = await axios.post<JsonResponse<AccountManager>>('dashboard/customer-support/emergency-support', { description });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetInvestmentGraph = async (duration: 'day' | 'week' | 'month' | '6months' = 'day') => {
	try {
		const response = await axios.get<JsonResponse<ShareGraph>>(`dashboard/company-overview/investment-graph-data?duration=${duration}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
